import { execute_generator } from './index'

export const msg_root = process.env.VUE_APP_API_MESSAGE_URL
const root_path = '/messages'

export const get_sensor_messages = body => execute_generator(
    'POST',
    { service: msg_root, resource: `${root_path}/search/sensordata` },
    body
).next()
